export default "__VITE_ASSET__DXcdvnIm__"